import { RootState } from '@app/redux/root-reducer';

export const selectInventoryTransactionState = (store: RootState) =>
  store.inventoryDetailSlice.inventoryTransaction;
